import { Checkbox } from '@any-ui-react/core';
import { InputLabel } from '@mantine/core';
import { useFormContext, useWatch } from 'react-hook-form';

import { EmployeeMaritalStatus } from '@/common/graphql';
import type { EmployeeAddFormDataType } from '@/common/types';

const EmployeeMaritalStatusLabels: Record<EmployeeMaritalStatus, string> = {
  [EmployeeMaritalStatus.Single]: 'Single',
  [EmployeeMaritalStatus.Married]: 'Married',
};

export const EmployeeMaritalStatusRadioGroup = () => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<EmployeeAddFormDataType>();
  const maritalStatus = useWatch({ control, name: 'maritalStatus' });

  return (
    <>
      <InputLabel>Marital Status</InputLabel>
      <div className="col-span-2 flex flex-row flex-wrap gap-4">
        {[EmployeeMaritalStatus.Single, EmployeeMaritalStatus.Married].map(key => (
          <Checkbox
            key={key}
            checked={maritalStatus === key}
            error={errors.maritalStatus?.message}
            label={EmployeeMaritalStatusLabels[key]}
            onChange={e => {
              setValue('maritalStatus', e.currentTarget.checked ? key : null, { shouldDirty: true });
            }}
          />
        ))}
      </div>
    </>
  );
};
